import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
export const usePortal = ({ parent = 'body' } = {}) => {
    const [isDomReady, setIsDomReady] = useState(false);
    useEffect(() => {
        setIsDomReady(true);
    }, []);
    const container = document.querySelector(parent) || document.body;
    return {
        createPortal: (children, id) => isDomReady ? createPortal(children, container, id) : null,
    };
};
